// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__32F4N","vLegacy":"SelectSecondary_vLegacy__8MJjC","error":"SelectSecondary_error__3TNjq","disabled":"SelectSecondary_disabled__2OYhu"};